
































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoComentarioStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import { maskHour, maskDate } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

@Component

export default class ComponentModalSolicitacaoComentario extends Vue {
  $refs!: { texto: any }
  texto: string = ''
  fb: boolean = false
  e0: boolean = false
  e24: boolean = false
  e48: boolean = false
  e72: boolean = false
  e7dias: boolean = false
  e10dias: boolean = false
  loadMensagem: boolean = false

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get active0() {
    return this.e0
  }

  set active0(value :boolean) {
    this.e0 = value
  }

  get active24() {
    return this.e24
  }

  set active24(value :boolean) {
    this.e24 = value
  }

  get active48() {
    return this.e48
  }

  set active48(value :boolean) {
    this.e48 = value
  }

  get active72() {
    return this.e72
  }

  set active72(value :boolean) {
    this.e72 = value
  }

  get activeSeteDias() {
    return this.e7dias
  }

  set activeSeteDias(value :boolean) {
    this.e7dias = value
  }

  get activeDezDias() {
    return this.e10dias
  }

  set activeDezDias(value :boolean) {
    this.e10dias = value
  }

  get getComentarioStore() {
    return getModule(SolicitacaoComentarioStore, this.$store)
  }

  get showModalSolicitacaoComentario() {
    return this.getComentarioStore.modal.comentario
  }

  set showModalSolicitacaoComentario(value: boolean) {
    this.getComentarioStore.setShowModalComentario(value)
  }

  get solicitacaoTemLembreteAtivo() {
    return this.getComentarioStore.comentarios.some((comentario: any) => comentario.lembreteConcluido === false)
  }

  @Watch('showModalSolicitacaoComentario')
  onChangeShowModalSolicitacaoComentario(value) {
    if (!value) {
      this.active0 = false
      this.active24 = false
      this.active48 = false
      this.active72 = false
      this.activeSeteDias = false
      this.activeDezDias = false
      this.fab = false
      this.getTexto = ''
      this.getComentarioStore.clearSolicitacaoId()
      this.getComentarioStore.clearComentarios()
    } else {
      this.scrollToMensagem()
      this.$nextTick(() => this.$refs.texto.focus())
    }
  }

  tempoRestante(dataFinal) {
    const endTime = moment(dataFinal)
    const duration = Math.floor(moment.duration(endTime.diff(moment())).asHours())
    return duration <= 1
      ? `${duration} hora para a conclusão deste lembrete`
      : `${duration} horas para a conclusão deste lembrete`
  }

  get getComentarios() {
    return this.getComentarioStore.comentarios || []
  }

  get getTexto() {
    return this.texto
  }

  set getTexto(value: string) {
    this.texto = value
  }

  get fab() {
    return this.fb
  }

  set fab(value: boolean) {
    this.fb = value
  }

  async enviarLembrete(horas: number) {
    this.fab = false
    switch (horas) {
      case 0:
        this.active0 = true
        this.active24 = true
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 24:
        this.active0 = true
        this.active24 = true
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 48:
        this.active0 = false
        this.active24 = false
        this.active48 = true
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 72:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = true
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 168:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = true
        this.activeDezDias = false
        break
      case 240:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = true
        break
      default:
        return false
    }

    const params: any = {
      solicitacaoId: this.getComentarioStore.solicitacaoId,
      lembretePrazo: horas,
    }

    const lembreteConcluidoPeloUsuario = horas === 0
    const response = lembreteConcluidoPeloUsuario
      ? await this.getComentarioStore.concluirLembrete()
      : await this.getComentarioStore.enviarLembrete(params)

    if (response.success) {
      EventBus.$emit('setLembrete', {
        solicitacaoId: this.getComentarioStore.solicitacaoId,
        concluido: lembreteConcluidoPeloUsuario,
      })

      await this.getComentarioStore.getComentariosBySolicitacaoId(this.getComentarioStore.solicitacaoId)
    }

    return false
  }

  async send() {
    this.loadingMensagem = true
    if (!['', null, undefined].includes(this.getTexto)) {
      const comentario = {
        texto: this.getTexto,
        usuarioNome: this.$user.profile.name,
        dataEnvio: moment().toISOString(),
      }

      await this.getComentarioStore.send(comentario)
      this.clearTexto()
      this.scrollToMensagem()
      this.$nextTick(() => this.$refs.texto.focus())
    }

    this.loadingMensagem = false
  }

  clearTexto() {
    this.getTexto = ''
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('l_main_scrollto')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 1000,
    }

    ele[0].scrollTo(option)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  formatDate(value: string) {
    return maskDate(value)
  }

  updated() {
    this.scrollToMensagem()
  }
}
